import apiClient from "@/api/apiClient";
import type { PaginatedDeployment } from "@/api/resources/deployments/types";
import { type Deployment } from "@/supabase.types";
import { spawnCreateApiFunction, spawnUpdateApiFunction, type ApiResourceConfig } from "@/utils/api";

const table = "deployments";
const query = "*, settings:deployment_settings(*), devices(id), users:users_to_deployments(user_id)";
export const apiConfigDeployments: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: ["name", "address_1", "address_2", "city", "country", "zipcode"],
  sortables: ["name", "created_at", "updated_at"],
};

export async function getDeployments(): Promise<PaginatedDeployment[]> {
  const { data, error } = await apiClient
    .from(table)
    .select(query)
    .is("deleted_at", null)
    .is("devices.deleted_at", null);
  if (error) throw error;
  return data;
}

export const getDeployment = async (match: Partial<Deployment>): Promise<PaginatedDeployment | null> => {
  const { data, error } = await apiClient
    .from(table)
    .select(query)
    .match(match)
    .is("deleted_at", null)
    .is("devices.deleted_at", null)
    .maybeSingle();
  if (error) throw error;
  return data;
};

export const createDeployment = spawnCreateApiFunction({ table, query });
export const updateDeployment = spawnUpdateApiFunction({ table, query });
export const deleteDeployment = async ({ id }: Pick<Deployment, "id">) => {
  const { error, ...rest } = await apiClient.rpc("delete_deployment", { _deployment_id: id });
  if (error) throw error;

  return { error, ...rest };
};
